import { useSelector } from 'react-redux'

export default id => {
  const module = useSelector(({ modules }) => modules[id])
  return module
}
